module.exports = __webpack_public_path__ + "phone.png?c1c351114fcc517c4cab4379520dd893";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 242
// module chunks = 0